import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('../views/order.vue')
  },
  {
    path: '/vdm-products',
    name: 'vdm-products',
    component: () => import('../views/VdmListView.vue')
  },
  {
    path: '/travel-category',
    name: 'travel-category',
    component: () => import('../views/TravelCategory.vue')
  },
  {
    path: '/kkday-product-management',
    name: 'kkday-product-management',
    component: () => import('../views/KkdayProductManagement.vue')
  },
  {
    path: '/kkday-order',
    name: 'kkday-order',
    component: () => import('../views/kkdayorder.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router